angular.module('qkr')
    .controller('userManagementController',
    function(_, $scope, $uibModal, userManagementService, messageService, merchantService, appConfig, gettextCatalog){
    $scope.userList = [];
    $scope.roleList = [];
    $scope.departmentList = [];
	$scope.loaded = false;
    $scope.sortedfields = {}; // used for toggling ascend/descend sorting
	
    $scope.isElevatedUser = appConfig.isElevatedUser;

	$scope.init = function() {
        userManagementService.loadRoleList().then((response) => {
            $scope.roleList = response;
        });

        $scope.loadUserList();
    };

    $scope.loadUserList = function() {
        userManagementService.loadUserList().then((response) => {
            $scope.userList = response;
            $scope.loaded = true;
            if ($scope.userList.length > 0) {
                $scope.sortByField('username');
                $scope.setArrow('username');
                $scope.showWelcome = false;
            } else {
                $scope.showWelcome = true;
            }
        });
    };

    $scope.createUser = function() {
    	const modalInstance = $uibModal.open({
            template: require('../templates/usermanagement/user.html'),
            controller: 'UserManagmentModalDialogController',
            windowClass: 'modal-huge',
            backdrop: 'static',
            resolve: {
            	userManagementContext() {
            		return userManagementService.getContext(appConfig.level);
            	},
                userAction() {
                    return 'create';
            	},
            	currentPartner() {
            		return null;
            	},
            	currentMerchant() {
            		return merchantService.merchantInfo;
            	},
                editUserRecord() {
                    return {};
                }
        	}
        });

        modalInstance.result.then((result) => {
            if (result === 'done') {
               $scope.reloadUserList();
            }
        }, () => {});
    };

    $scope.editUser = function(userListIndex) {
        const user = $scope.userList[userListIndex];

        const modalInstance = $uibModal.open({
            template: require('../templates/usermanagement/user.html'),
            controller: 'UserManagmentModalDialogController',
            windowClass: 'modal-huge',
            backdrop: 'static',
            resolve: {
            	userManagementContext() {
            		return userManagementService.getContext(appConfig.level);
            	},
                userAction() {
                    return 'edit';
                },
                currentPartner() {
            		return null;
            	},
            	currentMerchant() {
            		return merchantService.merchantInfo;
            	},
                editUserRecord() {
                    return user;
                }
            }
        });

        modalInstance.result.then((result) => {
            if (result === 'done') {
                $scope.reloadUserList();
            }
        }, () => {   

        });
    };

    $scope.deleteUser = function(user) {
        const modalInstance = $uibModal.open({
            template: require('../templates/common/modalDialog.html'),
            controller: 'commonModalDialogController',
            windowClass: 'fade',
            backdrop: 'static',
            resolve: {
                title() {
                    return gettextCatalog.getString('Delete User');
                },
                confirmButtonName() {
                    return gettextCatalog.getString('Delete');
                },
                confirmMsg() {
                    return gettextCatalog.getString('Are you sure you want to delete') + user.username + ' ?';
                },
                multiMsgArray() {
                    return [];
                }
            }
        });

        modalInstance.result.then((result) => {
            if (result === 'ok') {
                 userManagementService.deleteUser(user.id).then((response) => {
                    $scope.reloadUserList();
                });
            } 
        }, () => {});
    };

    $scope.sendActivateEmail = function(user) {
        const modalInstance = $uibModal.open({
            template: require('../templates/common/modalDialog.html'),
            controller: 'commonModalDialogController',
            windowClass: 'fade',
            backdrop: 'static',
            resolve: {
                title() {
                    return gettextCatalog.getString('Send activation e-mail');
                },
                confirmButtonName() {
                    return gettextCatalog.getString('Confirm');
                },
                confirmMsg() {
                    return gettextCatalog.getString('Are you sure you want to send an activation e-mail to') + ' ' + user.username + ' ?';
                },
                multiMsgArray() {
                    return [];
                }
            }
        });

        modalInstance.result.then((result) => {
            if (result === 'ok') {
                userManagementService.sendActivateEmail(user.id).then((response) => {
                    messageService.success(response.field);
                    $scope.reloadUserList();
                });
            } 
        }, () => {});
    };

    $scope.sortByField = function(field, subfield, index) {
        if (subfield){
            if (index || index === 0){
                $scope.userList = _.sortBy( $scope.userList,
                        user => user[field][index] ? user[field][index][subfield].toLowerCase() : '');
            }
            else{
                $scope.userList = _.sortBy( $scope.userList,
                        user => user[field][subfield] ? user[field][subfield].toLowerCase() : '');
            }
        }
        else {
            $scope.userList = _.sortBy( $scope.userList,
                    user => user[field] ? user[field].toLowerCase() : '');
        }

        if(!subfield){
            subfield = '';
        }
        if ($scope.sortedfields[field + subfield]){
            $scope.sortedfields[field + subfield] = false;
            $scope.userList.reverse();
        }
        else {
            $scope.sortedfields[field + subfield] = true;
        }
    };

        $scope.setArrow = function(active, hasSubfield) {
            $scope.usernameArrow = 'fa fa-sort';
            $scope.firstNameArrow = 'fa fa-sort';
            $scope.statusArrow = 'fa fa-sort';
            $scope.webUserRolesArrow = 'fa fa-sort';
            $scope.partnerArrow = 'fa fa-sort';

            const reverse = $scope.sortedfields[active];

            switch (active) {
                case ('username') :
                    if (reverse) {
                        $scope.usernameArrow = 'fa fa-sort-up';
                    } else {
                        $scope.usernameArrow = 'fa fa-sort-down';
                    }
                    break;
                case ('firstName') :
                    if (reverse) {
                        $scope.firstNameArrow = 'fa fa-sort-up';
                    } else {
                        $scope.firstNameArrow = 'fa fa-sort-down';
                    }
                    break;
                case ('status') :
                    if (reverse) {
                        $scope.statusArrow = 'fa fa-sort-down';
                    } else {
                        $scope.statusArrow = 'fa fa-sort-up';
                    }
                    break;
                case ('webUserRoles') :
                    if (reverse) {
                        $scope.webUserRolesArrow = 'fa fa-sort-down';
                    } else {
                        $scope.webUserRolesArrow = 'fa fa-sort-up';
                    }
                    break;
                case ('partner') :
                    if (reverse) {
                        $scope.partnerArrow = 'fa fa-sort-down';
                    } else {
                        $scope.partnerArrow = 'fa fa-sort-up';
                    }
                    break;
            }
            if(hasSubfield) {
                if (reverse) {
                    $scope.sortedfields[active] = false;
                }
                else {
                    $scope.sortedfields[active] = true;
                }
            }
        };

    $scope.reloadUserList = function() {
        $scope.userList = [];
        $scope.loaded = false;
        $scope.loadUserList();
    };
});



// WEBPACK FOOTER //
// ./src/controllers/user.management.controller.js